import { render, staticRenderFns } from "./VoucherBaseAddDetails.vue?vue&type=template&id=2fde9ff8&scoped=true"
import script from "./VoucherBaseAddDetails.vue?vue&type=script&lang=js"
export * from "./VoucherBaseAddDetails.vue?vue&type=script&lang=js"
import style0 from "./VoucherBaseAddDetails.vue?vue&type=style&index=0&id=2fde9ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde9ff8",
  null
  
)

export default component.exports